import React, { FunctionComponent } from 'react';
import { getImageUrl } from '../../../../utils/navigation';
import { formatCurrency } from '../../../../utils/wallets';
import './BingoCardWide.scss';
import { BingoData } from '../BingoCard';
import { Heading } from '../../../shared/Heading';
import { BingoProfileIcon, BingoJackpotIcon, PrizeIcon, CardCostIcon } from '../../../shared/SVG/Icons/';
import LazyLoadedImage from '../../../Media/LazyLoadedImage';
import { ballImages, formatTimeToStart } from '../shared';

interface BingoCardWideProps {
  bingo: BingoData;
  onPlay: () => void;
}

export const BingoCardWide: FunctionComponent<BingoCardWideProps> = ({ bingo, onPlay }): JSX.Element => {
  const {
    title,
    jackpot,
    prize,
    players = 0,
    number_of_balls,
    img,
    imgWide,
    roomID,
    hasRealTimeData,
    cardCost,
    timeToStart = -1,
  } = bingo;

  const imageUrl = getImageUrl(imgWide?.filename_disk || img?.filename_disk);

  const handleJoinRoom = (event: React.MouseEvent): void => {
    event.stopPropagation();

    if (roomID) {
      // Navigate to bingo room
      onPlay();
    }
  };

  return (
    <div className="bingo-card-wide">
      <div className="bingo-card-wide__image-container">
        {imageUrl ? (
          <LazyLoadedImage src={imageUrl} alt={title} className="bingo-card-wide__image" />
        ) : (
          <div className="bingo-card-wide__placeholder" />
        )}
        {timeToStart > 0 && <div className="bingo-card-wide__time-container">{formatTimeToStart(timeToStart)}</div>}
      </div>
      <div className="bingo-card-wide__content">
        <div className="bingo-card-wide__row">
          <div className="bingo-card-wide__left-section">
            <Heading className="bingo-card-wide__title" noMargin level={4}>
              {title}
            </Heading>
          </div>
          <div className="bingo-card-wide__right-section">
            {hasRealTimeData &&
              number_of_balls &&
              (ballImages[number_of_balls] ? (
                <LazyLoadedImage
                  src={ballImages[number_of_balls]}
                  alt={`${number_of_balls} Ball`}
                  className="bingo-card-wide__balls"
                />
              ) : (
                <div className="bingo-card-wide__balls-text">{number_of_balls} Ball</div>
              ))}
          </div>
        </div>

        {hasRealTimeData && (
          <div className="bingo-card-wide__game-info">
            <div className="bingo-card-wide__money-info">
              <div className="bingo-card-wide__jackpot">
                <BingoJackpotIcon className="bingo-card-wide__jackpot-icon" />
                <span className="bingo-card-wide__stat-value">
                  {jackpot ? formatCurrency(parseFloat(jackpot))?.replace(/\s/g, '') : '-'}
                </span>
              </div>
              <div className="bingo-card-wide__prize">
                <PrizeIcon className="bingo-card-wide__prize-icon" />
                <span className="bingo-card-wide__stat-value">
                  {prize ? formatCurrency(parseFloat(prize))?.replace(/\s/g, '') : '-'}
                </span>
              </div>
              <div className="bingo-card-wide__bet-range">
                <CardCostIcon className="bingo-card-wide__card-cost-icon" />
                <span className="bingo-card-wide__card-cost">
                  {cardCost ? `£${parseFloat(cardCost).toFixed(2)}` : '£0.00'}
                </span>
                <BingoProfileIcon className="bingo-card-wide__player-icon" aria-hidden="true" />
                <span className="bingo-card-wide__stat-value">{players || 0}</span>
              </div>
            </div>
            <div className="bingo-card-wide__right-section">
              <button className="bingo-card-wide__join-btn" onClick={handleJoinRoom}>
                {bingo.ctaText}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
